module.exports = __webpack_public_path__ + "img/insert-media.50c271b3.svg";